// this is an older version of the reducer in /shared/reducers,
// still relevant to the kiosk for now but can be reconciled by changing items to an object.
import {
  SET_PHOTOSWIPE_OPEN,
  SET_PHOTOSWIPE_INDEX,
  SET_PHOTOSWIPE_MOMENT,
  SET_PHOTOSWIPE_ITEMS
} from 'shared/actions/types';

import produce from 'immer';

const initialState = {
  open: false,
  index: 0,
  momentId: null,
  purchased: false,
  moment: {},
  items: []
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_PHOTOSWIPE_OPEN:
      return produce(state, draft => {
        draft.open = action.payload;
      }); case SET_PHOTOSWIPE_INDEX:
      return produce(state, draft => {
        draft.index = action.payload;
        draft.momentId = null;
      });

    case SET_PHOTOSWIPE_MOMENT:
      return produce(state, draft => {
        draft.momentId = action.payload.id;
        draft.purchased = action.payload.purchased;
        draft.moment = action.payload;
        draft.index = null;
      });

    case SET_PHOTOSWIPE_ITEMS:
      return produce(state, draft => {
        draft.items = action.payload;
      });

    default:
      return state;
  }
}
